import React, { useEffect } from 'react'

import StepItem from './step-items'

// import './index.css'

const MobileSteps = ({ Items }: { Items: any[] }) => {
  const renderMobileStepItems = () => {
    // const chunkSize = 2
    // const chunckedArr = []
    // for (let i = 0; i < Items.length; i += chunkSize) {
    //   const chunk = Items.slice(i, i + chunkSize)
    //   chunckedArr.push(chunk)
    //   // console.log(chunckedArr)
    // }

    // return chunckedArr.map((chunk, i) => {
    return (
      <div className={`mobile-steps-group relative mx-auto h-fit w-full pb-10`}>
        {Items.map((stepItem, i) => {
          return (
            <div className="w-full" key={`${stepItem.prominentText}-${i}`}>
              <StepItem
                imgSrc={stepItem.imgSrc}
                prominentText={stepItem.prominentText}
                prominentTextColor={stepItem.prominentTextColor}
                descriptionText={stepItem.descriptionText}
                descriptionTextColor={stepItem.descriptionTextColor}
                key={`${stepItem.prominentText}-${i}`}
                isMobile={true}
              />
            </div>
          )
        })}
      </div>
    )
    // })
  }

  return <>{renderMobileStepItems()}</>
}

export default MobileSteps
